import { Component, ViewChild, Input } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  App,
  AlertController,
} from 'ionic-angular';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { UserProvider } from '../../providers/user/user';
import * as _ from 'lodash';
import { MessagesProvider } from '../../providers/messages/messages';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';

@Component({
  selector: 'new-message-user-selector',
  templateUrl: 'new-message-user-selector.html',
})
export class NewMessageUserSelectorComponent {
  @ViewChild('newGroupChatSlideover')
  newGroupChatSlideover;
  @Input()
  conversation;
  loading;
  log = debug('app:NewMessageUserSelectorComponent');
  friends = [];
  friendsFilter = '';
  selectedFriends = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public loadingCtrl: LoadingController,
    public appCtrl: App,
    public messaging: MessagesProvider,
    public tools: ToolsProvider,
    public alertCtrl: AlertController,
    public userVerification: UserVerificationProvider
  ) {}

  ngOnInit(): void {
    this.getAllFriends();
  }

  ngOnDestroy(): void {
    this.conversation = {};
  }

  getAllFriends() {
    Promise.resolve()
      .then(res => {
        return this.crudApi.get('/api/friends', {
          accepted: true,
        });
      })
      .then(res => {
        this.log('friends ', res.data);
        let friendList = res.data;
        if (!this.conversation._id) {
          return (this.friends = res.data);
        } else {
          _.each(this.conversation.users, member => {
            _.remove(friendList, friend => {
              return friend._id === member._id;
            });
          });
          return (this.friends = friendList);
        }
      })
      .catch(e => {
        this.log('error: ', e);
      });
  }

  ionViewDidLoad() {
    this.log('ionViewDidLoad NewMessagePage');
  }

  addToSendList() {
    this.loading = true;
    this.selectedFriends = _.filter(this.friends, 'isChecked');
    setTimeout(() => {
      this.loading = false;
    }, 500);

    this.friendsFilter = '';
  }

  removeFromSendList(friend) {
    _.filter(this.selectedFriends, function (item) {
      if (item._id === friend._id) {
        _.set((item.isChecked = false));
      }
    });
  }

  async createIndividualChat() {
    if (!(await this.userVerification.isVerified())) {
      return;
    }

    let friend = this.selectedFriends[0];
    // go to individual chat
    if (friend) {
      this.tools.logAnalyticsEvent('trackCustom', 'friends-create-convo');
      this.tools.checkCanMessage().then(canMessage => {
        if (canMessage) {
          this.messaging.createNewConversation([friend._id]).then(convo => {
            // TODO navTo
            // this.tools.openExternalUrl(
            //   `/contacts/friends-message/${convo._id}`,
            //   'deep-link',
            //   {
            //     setTab: 'messages',
            //   }
            // );
            this.tools.navTo('FriendsMessagePage', 2, {
              conversation_id: convo._id,
              conversation: convo,
            });
          });
        }
      });
    }
    this.ngOnInit();
  }

  addMembersToExistingConversation() {
    if (this.conversation.users.length + this.selectedFriends.length > 9) {
      this.openRestrictionModal();
    } else {
      if (this.selectedFriends.length !== 0) {
        this.tools.checkCanMessage().then(canMessage => {
          if (canMessage) {
            this.messaging.addMoreMembersToGroup(
              this.selectedFriends,
              this.conversation
            );
          }
        });
      }
    }
  }

  openRestrictionModal() {
    const prompt = this.alertCtrl.create({
      title: 'Group chats can only support a maximum of 10 people.',
      cssClass: 'alertDeleteAccount',
      buttons: [
        {
          text: 'OK',
          cssClass: 'alert-button-cancel',
          handler: data => {
            console.warn('Cancel clicked');
          },
        },
      ],
    });
    prompt.present();
  }

  checkConvoExists() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...',
    });
    this.loading.present();

    this.messaging
      .doesConvoExist(_.map(this.selectedFriends, 'userId'))
      .then(convo => {
        this.loading.dismiss();

        if (convo) {
          // TODO navTo
          // this.tools.openExternalUrl(
          //   `/contacts/friends-message/${convo._id}`,
          //   'deep-link',
          //   {
          //     setTab: 'messages',
          //     conversation: convo,
          //   }
          // );
          this.tools.navTo('FriendsMessagePage', 2, {
            conversation_id: convo._id,
            conversation: convo,
          });
          this.clearSelectedFriends();
        } else {
          setTimeout(() => {
            this.newGroupChatSlideover.show();
          });
        }
      })
      .catch(e => {
        this.loading.dismiss();
      });
  }

  clearSelectedFriends() {
    setTimeout(() => {
      this.friends = _.map(this.friends, f => {
        return { ...f, isChecked: false };
      });
      this.selectedFriends = [];
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/new-message-user-selector/new-message-user-selector.ts